import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  variant?: 'dark' | 'light';
};

export const LanguageSwitcher: FC<Props> = ({ variant = 'light' }) => {
  const { i18n } = useTranslation();
  const current = i18n.language.startsWith('en') ? 'en' : 'ru';

  const base = 'text-xs font-semibold px-2.5 py-1 rounded-md transition-colors cursor-pointer';

  const active = variant === 'dark'
    ? 'bg-white/20 text-white'
    : 'bg-white text-gray-900 shadow-sm';

  const inactive = variant === 'dark'
    ? 'text-white/50 hover:text-white/80'
    : 'text-gray-400 hover:text-gray-600';

  const container = variant === 'dark'
    ? 'flex items-center gap-0.5 bg-white/10 rounded-lg p-0.5'
    : 'flex items-center gap-0.5 bg-gray-100 rounded-lg p-0.5';

  return (
    <div className={container}>
      <button className={`${base} ${current === 'ru' ? active : inactive}`} onClick={() => i18n.changeLanguage('ru')}>RU</button>
      <button className={`${base} ${current === 'en' ? active : inactive}`} onClick={() => i18n.changeLanguage('en')}>EN</button>
    </div>
  );
};
